import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:2000"; // ex: http://127.0.0.1:8000

export const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  withCredentials: false
});

// Attache le token (Bearer) si présent dans localStorage
api.interceptors.request.use((config) => {
  // Ne pas écraser un header Authorization déjà défini (pour les agents par exemple)
  if (!config.headers.Authorization) {
    const token = localStorage.getItem("auth_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Optionnel: gestion des 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // ex: rediriger vers /connexion ou vider le token
      // localStorage.removeItem("auth_token");
    }
    return Promise.reject(err);
  }
);
